import menusApi from '../../api/menus-api';
import cartesApi from '../../api/cartes-api';
import router from '../../router';

const menus = {
    items: [],
    item: {},
    listSelect: [],
};

const mutations = {
    setItemsMenus(state, payload) {
        state.items = payload.data;
    },
    setItemMenu(state, payload) {
        state.item = payload;
    },
    setSelectMenu(state, payload) {
        state.listSelect = payload.data;
    },
};

const actions = {
    async refreshMenus(context, { restaurant_id, language }) {
        if (!restaurant_id) {
            restaurant_id = this.getters.getCurrentRestaurant;
        }
        context.commit('loading', true);
        const res = await menusApi.getAllByRestaurant(restaurant_id, language);
        context.commit('loading', false);
        context.commit('setItemsMenus', res.data);
    },
    async getAllMenusPublicSimple(context, { restaurant_id, language }) {
        if (!restaurant_id) {
            restaurant_id = this.getters.getCurrentRestaurant;
        }
        const res = await menusApi.getAllByRestaurantPublic(restaurant_id, language);
        context.commit('setItemsMenus', res);
    },
    async getMenu(context, { id, language }) {
        context.commit('setItemMenu', {});
        const res = await menusApi.getOne(id, language);
        context.commit('setItemMenu', res.data.data);
    },
    async getMenuPublic(context, { id, slug, language }) {
        const res = await menusApi.getOnePublic(id, slug, language);
        context.commit('setItemMenu', res.data.data);
    },
    createMenu({ commit, dispatch }, { menu, language }) {
        commit('loading', true);
        menusApi.create(menu, language).then(
            (response) => {
                commit('notifications', { title: 'menu.MenuCreado' });
                commit('loading', false);
                router.push({ name: 'menus' });
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'menu.NotMenuCreado', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },




    editMenu({ commit, dispatch }, { id, menu, groups, language, newLanguage }) {
        commit('loading', true);

        if (groups) {
            for (let i = 0; i < groups.length; i++) {
                if (groups[i].id === 'NEW') {
                    dispatch('createMenuGroup', { idMenu: id, group: groups[i], language });
                } else if (groups[i].id) {
                    dispatch('editMenuGroup', { id: groups[i].id, group: groups[i], language });
                }
            }
        }

        menusApi.edit(id, menu, language).then(
            (response) => {
                commit('notifications', { title: 'menu.MenuEditado' });
                if (newLanguage) {
                    dispatch('getMenu', { id, language: newLanguage });
                }
                commit('loading', false);
                router.push({ name: 'menus' });
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'menu.NotMenuEditado', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
    deleteMenu({ commit, dispatch }, id) {
        commit('loading', true);
        menusApi.delete(id).then(
            (response) => {
                dispatch('refreshMenus', {});
                commit('notifications', { title: 'menu.MenuEliminado' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'menu.NotMenuEliminado', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
    editMenuGroup({ commit }, { id, group, language }) {
        menusApi.editGroup(id, group, language);
    },
    createMenuGroup({ commit }, { idMenu, group, language }) {
        menusApi.createGroup(idMenu, group, language);
    },
    deleteMenuGroup({ commit }, idGroup) {
        commit('loading', true);
        menusApi.deleteGroup(idGroup).then(
            (response) => {
                commit('notifications', { title: 'menu.GrupoEliminado' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'menu.NotGrupoEliminado', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
    activeMenu({ commit, dispatch }, id) {
        commit('loading', true);
        menusApi.active(id).then(
            (response) => {
                dispatch('refreshMenus', {});
                commit('notifications', { title: 'menu.MenuActivado' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'menu.NotMenuActivado', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
    deactiveMenu({ commit, dispatch }, id) {
        commit('loading', true);
        menusApi.deactive(id).then(
            (response) => {
                dispatch('refreshMenus', {});
                commit('notifications', { title: 'menu.MenuDesactivado' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'menu.NotMenuDesactivado', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
};

const getters = {
    getMenus: (state) => state.items,
    getMenu: (state) => state.item,
    menusListSelect: (state) => state.listSelect,
};

export default {
    state: menus,
    mutations,
    actions,
    getters,
};
